'use client'

import React, { use } from 'react'
import { loadLocale } from 'locales/localLoader'
import Checkout from './components/checkout'
import {
  Paper,
  Stack,
  Title,
  Divider,
  useMantineTheme,
  Alert,
  Center,
  Group,
  Text
} from '@mantine/core'
import { FaInfoCircle } from 'react-icons/fa'
import { useMediaQuery } from '@mantine/hooks'

export default function StripePage({
  params
}: {
  params: Promise<{ lang: string; code: string; plan: string }>
}) {
  const { lang, code, plan } = use(params)

  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const locale = loadLocale(lang)

  return (
    <Stack>
      <Stack gap="lg" align="right">
        <Group ml="xl" mr="xl">
          <Stack gap={0}>
            <Title size={50} c="redi-green.0">
              {locale?.stripe?.almost_ready} <br /> {locale?.stripe?.be_redi}.
            </Title>
            <Title order={2} c="white">
              {locale?.stripe?.choose_payment}
            </Title>
          </Stack>
          <Alert
            p='xs'
            radius="md"
            bg="white"
            color="black"
            variant="outline"
            ml="auto"
            mt="auto"
            mb="xs"
            maw={550}
            title={locale?.stripe?.where_receive_esim}
            icon={<FaInfoCircle />}
          >
            {locale?.stripe?.esim_delivery_message} <Text component='span' c="redi-blue.0" fw={500}> {locale?.stripe?.esim_delivery_message_warning}</Text>
          </Alert>
        </Group>

        <Center>
          <Paper bg={'transparent'} w="100%">
            <Paper
              // mb="lg"
              ml={isMobile ? -20 : 0}
              mr={isMobile ? -20 : 0}
              pt="lg"
              pb="lg"
              pl={isMobile ? 'xs' : 'lg'}
              pr={isMobile ? 'xs' : 'lg'}
              radius={isMobile ? 0 : 'xl'}
              mih={617}
            >
              <Checkout plan={plan} code={code} lang={lang} />
            </Paper>
          </Paper>
        </Center>
      </Stack>
    </Stack>
  )
}
